module.exports = __webpack_public_path__ + "static/Basic-7ecc4bded9039549e20ea663867faae2.png";